const settings = {
    data () {
        return {
            settings: {
                open: false,
                left: 0
            }
        }
    },
    methods: {
        toggleSettings (e) {
            if (this.settings.open) {
                this.closeSettings()
            } else {
                this.settings.open = true
                let rect = e.path[1].getBoundingClientRect()
                this.settings.left = rect.x;
            }

        },
        closeSettings () {
            this.settings.open = false
            this.settings.left = 0;
        }
    }
}

export default settings